import { render, staticRenderFns } from "./SkuCustom.vue?vue&type=template&id=41b8992f&scoped=true&"
import script from "./SkuCustom.vue?vue&type=script&lang=ts&"
export * from "./SkuCustom.vue?vue&type=script&lang=ts&"
import style0 from "./SkuCustom.vue?vue&type=style&index=0&id=41b8992f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b8992f",
  null
  
)

export default component.exports